import { dispatch } from '../../jsCore/application/appStore'
import { CLASS_CONSTATNTS } from '../../jsCore/organizedByType/actions/analyticsActions'

function pushConsentToDataLayer(consent) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Cookie consent',
        action: 'user consent status',
        label: ' ',
        cookieConsent: consent,
      },
    },
  }
}

function renderCcpa() {
  if (window.__cmp) {
    window.__cmp('uspPing', null, function(obj, status) {
      if (status && (obj.location === 'ca' || obj.location === 'CA')) {
        window.__cmp('setUspDftData', 1, function(obj, status) {})
        let hamburger = document.getElementsByClassName('items-list scroll')
        hamburger[0].childNodes[hamburger[0].childNodes.length - 1].insertAdjacentHTML(
          'afterend',
          `<div class="items-list__item-name"><a onclick="window.__cmp('displayUspUi')" class="items-list__link" href="#">Do Not Sell My Data</a></div>`
        )
      }
    })
  }
}
export function init() {
  window.__cmp('getConsentData', null, function(result) {
    localStorage.setItem('gdprApplies', result.gdprApplies)
    localStorage.setItem('consentData', result.consentData)
    if (null !== result.consentData) {
      dispatch(pushConsentToDataLayer(result.consentData))
    }
    setTimeout(function() {
      renderCcpa()
    }, 2000)
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/cookie_consent/cookieConsentUtils.js